module.exports = __webpack_public_path__ + "static/media/shopify_logo_black.b6457d76.svg";